import './navigation.js';
import { initFooter } from './footer.js';

/* Light/Dark and grid density are site-wide browser preferences.
 * The head bootstrap migrates former System users before first paint.
 */

import './card-photos.js';

const STORAGE_KEY = 'mx_theme';
const root = document.documentElement;
const lightThemeColor = document.querySelector('#mx-theme-color-light');
const darkThemeColor = document.querySelector('#mx-theme-color-dark');

function applyThemeColor(preference) {
  if (!(lightThemeColor instanceof HTMLMetaElement) || !(darkThemeColor instanceof HTMLMetaElement)) return;

  lightThemeColor.media = preference === 'light' ? 'all' : 'not all';
  darkThemeColor.media = preference === 'dark' ? 'all' : 'not all';
}

function currentPreference() {
  return root.dataset.theme === 'light' || root.dataset.theme === 'dark'
    ? root.dataset.theme
    : window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

function store(preference) {
  try {
    localStorage.setItem(STORAGE_KEY, preference);
  } catch {
    // Storage can be unavailable in private or locked-down browser contexts.
    // The live choice still works for the current page.
  }
}

function apply(preference) {
  if (preference !== 'light' && preference !== 'dark') return;
  root.dataset.theme = preference;
  applyThemeColor(preference);
  store(preference);
}

function initAppearance() {
  apply(currentPreference());
  initColumns();
  initFooter();
  document.querySelectorAll('[data-mx-appearance-menu]').forEach((menu) => { menu.hidden = false; });
  document.querySelectorAll('[data-mx-appearance]').forEach((group) => {
    const controls = [...group.querySelectorAll('input[name="mx_appearance"]')];
    const selected = controls.find((control) => control.value === currentPreference());
    if (selected) selected.checked = true;

    group.addEventListener('change', (event) => {
      const control = event.target;
      if (!(control instanceof HTMLInputElement) || !control.checked) return;
      apply(control.value);
    });
  });
}

/*
 * How many listings across.
 *
 * The cookie is already applied by the inline boot script in the document head,
 * before the first paint; this only wires the select and shows its current value.
 * Changing it sets the variable live rather than reloading — the grid is CSS, so
 * there is nothing to fetch.
 *
 * A year on the cookie, `samesite=lax` because it is a display preference that
 * never needs to travel with a cross-site request, and no URL parameter anywhere:
 * ?cols=3 would mint a second crawlable address for every page of a catalogue that
 * depends on search traffic.
 */
function initColumns() {
  const group = document.querySelector('[data-mx-view]');
  if (!group) return;

  const root = document.documentElement;
  const select = group.querySelector('select[data-mx-cols]');
  if (!select) return;

  const current = () => {
    const inline = root.style.getPropertyValue('--mx-cols').trim();
    return inline || getComputedStyle(root).getPropertyValue('--mx-cols').trim();
  };

  select.value = current();
  select.addEventListener('change', () => {
    const cols = select.value;
    if (!/^[2-5]$/.test(cols)) return;
    root.style.setProperty('--mx-cols', cols);
    document.cookie = `mx_cols=${cols}; path=/; max-age=31536000; samesite=lax`;
  });

  group.hidden = false;
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAppearance);
} else {
  initAppearance();
}
